import connection from "../../utils/connection";

const getConfiguracionCliente = async (tenantId = "current") => {
  let response = {};

  try {
    const responseGet = await connection({
      url: `/configuracion-cliente/${tenantId}`,
      method: "GET",
    });

    response.data = responseGet;
  } catch (error) {
    console.error("catch service getConfiguracionCliente", error);
    response = error.response || {};
  }

  return response;
};

export default getConfiguracionCliente;


